import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class GameboyBadge extends WritingBadge {
  public readonly id = BadgeId.gameboy;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.streakInfo.current >= 30 || stats.streakInfo.longest >= 30;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/gameboy.ts